import {AppLayout} from "../layout/AppLayout.tsx";
import {PublicHomePage} from "../features/home/pages/PublicHomePage.tsx";
import {SignOutPage} from "../features/home/pages/SignOutPage.tsx";
import {AboutPage} from "../features/home/pages/AboutPage.tsx";
import {ProductsPage} from "../features/home/pages/ProductsPage.tsx";
import {RequireAuth} from "../utils/RequireAuth.tsx";
import {PricingConfigProvider, PricingPage} from "@flexinet/pricing-components";
import {publicPricingConfig} from "./pricing.ts";
import {DashboardLayout} from "../features/dashboard/layout.tsx";
import {ApplicationProductsLayout} from "../features/application-products/layout.tsx";
import {ApplicationErrorPage} from "@flexinet/ui-components";

export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    // Without this, a throw anywhere in the tree unmounts the router and leaves
    // a white screen. It sits on the root route so it catches every descendant:
    // react-router walks up to the nearest errorElement, and there is only one.
    // FNP-1412.
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'about',
        element: <AboutPage/>
    }, {
        path: 'products',
        element: <ProductsPage/>
    }, {
        path: 'pricing',
        element: <PricingConfigProvider config={publicPricingConfig}><PricingPage/></PricingConfigProvider>
    }, {
        // Wildcards: each module owns its own sub-routes from here down, so
        // adding one no longer means editing this file. FNP-1412.
        path: 'dashboard/*',
        element: <RequireAuth><DashboardLayout/></RequireAuth>
    }, {
        path: 'application-products/*',
        element: <RequireAuth><ApplicationProductsLayout/></RequireAuth>
    }]
}]
